// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-app-js": () => import("./../src/pages/app/app.js" /* webpackChunkName: "component---src-pages-app-app-js" */),
  "component---src-pages-app-detail-js": () => import("./../src/pages/app/Detail.js" /* webpackChunkName: "component---src-pages-app-detail-js" */),
  "component---src-pages-app-home-js": () => import("./../src/pages/app/Home.js" /* webpackChunkName: "component---src-pages-app-home-js" */),
  "component---src-pages-callback-js": () => import("./../src/pages/callback.js" /* webpackChunkName: "component---src-pages-callback-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

